<div class="content-container">
    <button class="button" (click)="resetView()">Reset Camera</button>
    <div class="checkbox">
        <input id="toggleGround" class="show-for-sr" type="checkbox" [formControl]="groundControl">
        <label for="toggleGround" class="inline">
            Show Ground
            <span class="checkbox-box" aria-hidden="true" styledCheckbox>
                <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
            </span>
        </label>
    </div>
</div>